import { lazy } from 'react';
export * from './guidbook-layout.screen';
export var RequirementsScreen = lazy(function () { return import('./requirements.screen'); });
export var MaterialsScreen = lazy(function () { return import('./materials.screen'); });
export var IssuersScreen = lazy(function () { return import('./issuers.screen'); });
export var ConstructionsScreen = lazy(function () { return import('./constructions.screen'); });
